export default class EdibleCollection
{
	constructor(collection)
	{
		this.setEdibles(collection);
	}

	setEdibles(collection)
	{
		this.collection = collection;

		return this;
	}

	getEdibles()
	{
		return this.collection;
	}
}
